/**
	* Compress image
	* 
	* @param {File} blob - Input file
*/

export function compressImage(inputFile:File, sizeMb:number = 2, percentReduce:number = 0.05) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		
		reader.onload = function (event) {
			const img = new Image();
			
			img.onload = function () {
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				
				let compression = 1 - percentReduce;
				
				const compress = (width:number, height:number) => {
					const maxWidth = img.width * compression; // Maximum width for the compressed image
					const maxHeight = img.height * compression; // Maximum height for the compressed image
					
					// Calculate new dimensions if the image is too large
					if (width > maxWidth || height > maxHeight) {
					  if (width > height) {
						height = Math.round((height * maxWidth) / width);
						width = maxWidth;
					  } else {
						width = Math.round((width * maxHeight) / height);
						height = maxHeight;
					  }
					}
					
					canvas.width = width;
					canvas.height = height;
					
					ctx.drawImage(img, 0, 0, width, height);
					
					canvas.toBlob(
					  function (blob) {
						// Check if the compressed image is within the desired size limit
						if (blob.size <= sizeMb * 1024 * 1024) {
						  resolve(blob);
						} else {
						  compression -= percentReduce;
						  compress(canvas.width, canvas.height);
						}
					  },
					  inputFile.type || 'image/jpeg', // Use the original file type if available
					  compression // Compression quality
					);
				}
				
				compress(img.width, img.height);
			};
			
			img.src = event.target.result as string;
		};
		
		reader.onerror = function (event) {
			reject(new Error('Failed to read the image file.'));
		};
		
		reader.readAsDataURL(inputFile);
	});
}